import React, { useState, useEffect } from "react";

import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";

import { styled } from "@mui/system";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { getStockDetails } from "../Service/data";

const StyledTableContainer = styled(TableContainer)({
  width: 500,
  maxHeight: 300,
  marginTop: 20,
});

const StyledTableCell = styled(TableCell)({
    padding: 0,
  })

const StockDetailTable = (props) => {
  const [data, setData] = useState();
  const [noData, setNoData] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        getStockDetails(props.title).then((data) => {
          setData(data);
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (data !== undefined && data !== null) {
      setLoading(false);
      setNoData(false);
    }
  }, [data]);

  return (
    <div>
      {loading && <CircularProgress />}
      {noData && <Typography>No data was received</Typography>}
      {noData ? (
        <Typography>No data was received</Typography>
      ) : (
        <StyledTableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell>Property</StyledTableCell>
                <StyledTableCell>Value</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <StyledTableCell>Ticker</StyledTableCell>
                <StyledTableCell>{data.symbol}</StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell>Company</StyledTableCell>
                <StyledTableCell>{data.company}</StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell>Country</StyledTableCell>
                <StyledTableCell>{data.country}</StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell>Industry</StyledTableCell>
                <StyledTableCell>{data.industry}</StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell>Exchange</StyledTableCell>
                <StyledTableCell>{data.exchange}</StyledTableCell>
              </TableRow>
            </TableBody>
          </Table>
        </StyledTableContainer>
      )}
    </div>
  );
};

export default StockDetailTable;
